<template>
  <div class="px-6 py-10">
    <!-- Page Title -->
    <h1 class="text-2xl font-medium text-gray-800 mb-8 p-6">Messages</h1>

    <div>
      <!-- دکمه‌ها / باکس‌ها -->
      <div class="flex justify-center space-x-4 mb-6">
        <button
            v-for="item in items"
            :key="item.id"
            @click="selected = item.id"
            :class="[
            'flex flex-col items-center px-6 py-4 border rounded-lg shadow-sm cursor-pointer transition-colors hover:border-gray-400 hover:bg-white hover:shadow-md hover:text-gray-800',
            selected === item.id
              ? 'border-gray-400 bg-white shadow-md'
              : 'border-transparent text-primary'
          ]"
        >
          <!-- آیکون -->
          <component :is="item.icon" class="w-8 h-8 mb-2" />

          <!-- متن -->
          <span
              :class="selected === item.id ? 'text-gray-800' : 'text-orange-400'"
              class="text-sm"
          >
            {{ item.label }}
          </span>
        </button>
      </div>

      <!-- محتوای بخش انتخاب شده -->
      <div>
        <component :is="currentComponent" @refresh="handleRefresh" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import { Inbox, Mail, FolderArchive } from "lucide-vue-next"
import MessageBox from "@/components/message/MessageBox.vue"
import MessageNew from "@/components/message/MessageNew.vue"
import MessageArchived from "@/components/message/MessageArchived.vue"

const items = [
  {
    id: "mailbox",
    label: "Mailbox",
    icon: Inbox,
    component: MessageBox,
  },
  {
    id: "newmessage",
    label: "New Message",
    icon: Mail,
    component: MessageNew,
  },
  {
    id: "archived",
    label: "Archived",
    icon: FolderArchive,
    component: MessageArchived,
  },
]

const selected = ref("mailbox")

const currentComponent = computed(() => {
  const found = items.find((item) => item.id === selected.value)
  return found ? found.component : null
})

const handleRefresh = () => {
  selected.value = "mailbox"
}
</script>
